import cn from "@/utils/class-names";
import newsletterImg from "@public/newsletter-8.jpg";
import NewsLetterForm from "./newsletter-form";

export default function NewsLetter({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                className,
                "grid grid-cols-7 overflow-hidden rounded-2xl border border-gray-100 bg-white dark:bg-gray-50",
            )}
        >
            <div className="relative col-span-3 hidden aspect-[36/45] @[700px]:inline-block">
                <img
                    src={newsletterImg}
                    alt="newsletter"
                    // fill
                    // priority
                    sizes="(max-width: 768px) 140px"
                />
            </div>
            <div className="col-span-full flex flex-col items-start justify-center rounded-xl p-6 @[700px]:col-span-4 @[700px]:!items-center @[700px]:pl-8">
                <div className="w-full @[700px]:max-w-[440px]">
                    <div className="mb-8 text-center text-black dark:text-white">
                        <h2 className="mx-auto mb-3 text-xl @2xl:text-2xl @7xl:text-3xl @7xl:leading-10 @[700px]:mb-4">
                            Special offers are waiting for you!
                        </h2>
                        <p className="mx-auto max-w-[26ch] text-sm leading-6 text-gray-500 @2xl:text-base dark:text-gray-600">
                            Subscribe to our newsletter
                        </p>
                    </div>
                    <NewsLetterForm />
                </div>
            </div>
        </div>
    );
}
